import { getSessionStorageItem, setSessionStorageItem } from '@revenuemarket/browser';

const OAUTH_SIGNUP_KEY = 'oauth_signup_context';

export interface OauthSignupContext {
  providerType: string;
  email?: string;
  name?: string;
  phone?: string;
  oauthConnectionToken?: string;
}

export function getOauthSignupContext(): OauthSignupContext | undefined {
  return getSessionStorageItem<OauthSignupContext>(OAUTH_SIGNUP_KEY);
}

export function setOauthSignupContext(context: OauthSignupContext) {
  setSessionStorageItem(OAUTH_SIGNUP_KEY, context);
}
